import _ = require("underscore");
import ol = require("ol");
import Utils = require("../utils");
import Portal = require("portal-gis");
import Base = require("./base-command");
import geo = require("../utils/geo");

function intersects(ext1, ext2) {
    return ol.extent.intersects(ext1, ext2);
}

function getCenter(extent) {
    return ol.extent.getCenter(extent);
    //return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
}

// converts a hierarchy into a flat array, replaces duplicates
function flatten<T extends { id?: string }>(items: T[], map: (a: T) => T[], result: Rhythm.GIS.Dictionary<T>) {
    items && items.forEach(item => {
        result[item.id] = item;
        flatten(map(item), map, result);
    });
    return result;
}

class Handler extends Base<{
    out: {
        id: string;
        //layer: any; // ol layer
    }
}> {

    static about = `
If layer is decorated with an extent then ensure that extent is visible when layer is made visible

Usage Example:

    <EVENT about="If layer is decorated with an extent then ensure that extent is visible when layer is made visible" event="show-layer" id="show-layer-handler" mid="app/commands/show-layer-handler">
    <OPTIONS>
        <Values id="panmap" value="true" />
        <Values id="zoommap" value="true" />
    </OPTIONS>
    </EVENT>

    `;

    static options = {
        "zoommap": {
            "about": "allow the map to zoom in/out to achieve change in extent",
            "default": "false",
        },
        "panmap": {
            "about": "allow the map to pan to achieve change in extent",
            "default": "false",
        },
        "lazy": {
            "about": "If true, extent is unchanged if it intersects with the desired extent (i.e. we are close enough)",
            "default": "true",
        },
    }

    static output = {
        "center": {
            "about": "center of the extent",
        },
        "extent": {
            "about": "desired extent",
        },
        "layer": {
            "about": "layer identified by the _id_ output argument, which is specified in the Layer configuration",
        },
        "pan": {
            "about": "true when map is allowed to pan",
        },
    }
    
    execute(args = this.args) {

        let options = _.defaults(this.options, {
            "zoommap": "false",
            "panmap": "false",
            "lazy": "true"
        });

        // jumps to the appropriate area, TODO: consider moving to a map-show-layer handler.
        let allowPan = "true" === options["panmap"];
        let allowZoom = "true" === options["zoommap"];
        (allowPan || allowZoom) && this.mediator.mapView(mapView => {
            // where does this out.id come from?  Is it the Layer configuration?
            let layer = this.mediator.findLayer(args.out.id);
            if (layer && layer.extent) {
                let currentExtent = mapView.extent;
                let extent = geo.asExtent(layer.extent);

                if (options["lazy"] !== "false") {
                    if (intersects(currentExtent.geometry, extent.geometry)) return;
                }

                if (allowZoom) {
                    mapView.extent = extent;
                    this.trigger({
                        layer: layer,
                        extent: extent,
                        pan: true
                    });
                } else {
                    let center = getCenter(extent.geometry);
                    mapView.panTo(center);
                    this.trigger({
                        layer: layer,
                        extent: extent,
                        center: center
                    });
                }

            }
        });

    }
}

export = Handler; 